import { ApplicationHome } from 'components/home/ApplicationHome';
const ApplicationHomeContainer = ApplicationHome;
export { ApplicationHomeContainer };
